import { 
  baseUrl, 
  handleResponse, 
  handleError, 
  GetHeaders
} from "../../../apis/common/ApiUtils";

const apiUrl = baseUrl + "Pto";

export function myPtoDetails() {
  let url = `${apiUrl}/user/details`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getPtoDetails_Manager(employeeId) {
  let url;

  url = `${apiUrl}/manager/details/${employeeId}`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getPtoDetails_Admin(employeeId) {
  const url = `${apiUrl}/admin/details/${employeeId}`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getPtoTotals_Manager() {

  let url = `${apiUrl}/manager/totals`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getPtoTotals_Admin() {
  const url = `${apiUrl}/admin/totals`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

// Admin API functions

export function getAllEmployees() {
  const url = `${apiUrl}/admin/employees`;
  
  return fetch(url, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}